import styled from 'styled-components';

export default styled.span<{ h?: number, times?: number }>`
    display: block;
    height: ${({ h, times = 1 }) => `${h || times * 22}px`};
`;
